import type {
  IHttpCall,
  IHttpRequest,
  IHttpResponse,
} from '@hc-frontend/core-utils-net';
import { fetchBasedCall } from '@hc-frontend/core-utils-net';

import {
  GetSrcConfigurationRequestDto,
  GetSrcConfigurationResponseDto,
} from './get-src-configuration.types';

export type GetSrcConfigurationOptions = Partial<
  Omit<IHttpRequest<void>, 'body'>
> & {
  httpCall?: IHttpCall;
};

export function getSrcConfiguration(
  baseUrl: string,
  payload: GetSrcConfigurationRequestDto,
  options?: GetSrcConfigurationOptions,
): Promise<IHttpResponse<GetSrcConfigurationResponseDto>> {
  const { httpCall = fetchBasedCall, headers, ...restOptions } = options ?? {};

  const request: IHttpRequest<void> = {
    url: `${baseUrl}/reflexive-journey/api/v1/src-configuration/${payload.src}`,
    method: 'GET',
    headers,
    schemas: {
      response: GetSrcConfigurationResponseDto,
    },
    ...restOptions,
  };

  return httpCall(request);
}
